export enum EMarqueAppareilAir {
    AES = 1,
    Biomerieux,
    MBV,
    Merck,
    PBI,
    VWR,
}